module.exports = __webpack_public_path__ + "img/13.f56419ae.jpeg";